module.exports = __webpack_public_path__ + "media/24.483a2844.wav";